
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live/[cid]/[id]",
      function () {
        return require("private-next-pages/live/[cid]/[id]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live/[cid]/[id]"])
      });
    }
  